import FormLogin from "../components/common/form/FormLogin.jsx";

const Login = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-300">
      <div className="flex flex-col px-8 py-8 items-center bg-white rounded-md shadow-2xl space-y-8">
        <h1 className="font-bold text-xl">Log in</h1>
        <FormLogin />
      </div>
    </div>
  );
};

export default Login;
